import { trigger, animate, style, group, query, transition } from '@angular/animations';

export const routerTransition = trigger('routerTransition', [
    transition(':decrement', [
        query(':enter, :leave', style({ position: 'absolute', top: '56px', width: '100%' }), { optional: true }),
        group([
            query(':enter', [style({ right: '100%' }), animate('0.4s ease-in-out', style({ right: '0' }))], {
                optional: true,
            }),
            query(':leave', [style({ left: '0' }), animate('0.4s ease-in-out', style({ left: '100%' }))], {
                optional: true,
            }),
        ]),
    ]),
    transition(':increment', [
        group([
            query(':enter, :leave', style({ position: 'absolute', top: '56px', width: '100%' }), { optional: true }),
            query(':enter', [style({ left: '100%' }), animate('0.4s ease-in-out', style({ left: '0' }))], {
                optional: true,
            }),
            query(':leave', [style({ right: '0' }), animate('0.4s ease-in-out', style({ right: '100%' }))], {
                optional: true,
            }),
        ]),
    ]),
]);
